import { loading, handleErrorException } from 'State/actions';
import * as types from './types';

export const getProductionReports = (filter) => async (
  dispatch,
  getstate,
  MPWWebApi
) => {
  dispatch(loading(types.PRODUCTION_REPORT_SETUP_GRID_LOADING, true));

  try {
    const reports = await MPWWebApi.getGeneric(
      'production/GetProductionReportSetup'
    );

    dispatch({
      type: types.PRODUCTION_REPORT_SETUP_GET_REPORTS,
      payload: reports,
    });
  } catch (ex) {
    dispatch(
      handleErrorException(ex, types.PRODUCTION_REPORT_SETUP_ERROR, {
        Title: 'Error',
        Message: 'Could not load production reports.',
      })
    );
  }

  dispatch(loading(types.PRODUCTION_REPORT_SETUP_GRID_LOADING, false));
};

export const clearError = () => {
  return (dispatch) => {
    dispatch({ type: types.PRODUCTION_REPORT_SETUP_CLEAR_ERROR });
  };
};

export const changeModalVisiblity = (modal, show) => ({
  type: types.PRODUCTION_REPORT_SETUP_MODAL_VISIBILITY,
  payload: { modal, show },
});

export const changePage = (page) => ({
  type: types.PRODUCTION_REPORT_SETUP_CHANGE_PAGE,
  payload: { page },
});

export const setSelectedTemplate = (template) => ({
  type: types.PRODUCTION_REPORT_SETUP_MODAL_SET_SELECTED_TEMPLATE,
  payload: { template },
});

export const setMealTypes = (mealTypes) => ({
  type: types.PRODUCTION_REPORT_SETUP_MODAL_SET_MEAL_TYPES,
  payload: { mealTypes },
})

export const setMealType = (mealType) => ({
  type: types.PRODUCTION_REPORT_SETUP_MODAL_SET_MEAL_TYPE,
  payload: { mealType },
});

export const removeMealType = (mealType) => ({
  type: types.PRODUCTION_REPORT_SETUP_MODAL_REMOVE_MEAL_TYPE,
  payload: { mealType },
});

export const setNewReportOtherDetails = (value) => ({
  type: types.PRODUCTION_REPORT_SETUP_MODAL_SET_NEW_REPORT_OTHER_DETAILS,
  payload: value,
});

export const setNewReportDetails = (value) => ({
  type: types.PRODUCTION_REPORT_SETUP_MODAL_SET_NEW_REPORT_DETAILS,
  payload: value,
});

export const setNewReportNotes = (value) => ({
  type: types.PRODUCTION_REPORT_SETUP_MODAL_SET_NEW_REPORT_NOTES,
  payload: value,
});

export const saveReport = (value) => {
  return async (dispatch, getState, MPWWebApi) => {
    value.IsConfig = true;
    try {
      const res = await MPWWebApi.postGenericInsertUpdate(
        'production/SaveProductionReportSetup',
        value
      );      

      return res.data.Data;
    } catch (ex) {
      dispatch(
        handleErrorException(ex, types.PRODUCTION_REPORT_SETUP_ERROR, {
          Title: 'Error',
          Message: 'Could not create a new production report.',
        })
      );
    }
  };
};



// WEBPACK FOOTER //
// ./src/pages/productionreportsetup/state/reports/actions.js